(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      // Measure the header bar only (the logo overhangs it and must not inflate the value).
      const bar = this.querySelector('.custom-header__inner') || this.header;
      document.documentElement.style.setProperty('--header-height', `${bar.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
  }

  /* ---------- Hover-to-open dropdowns (desktop, mouse only) ---------- */
  (function () {
    if (window.__customHeaderHover) return;
    window.__customHeaderHover = true;

    const canHover = window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 990px)');
    const SELECTOR = '.custom-header[data-hover-dropdown] .custom-header__nav-wrapper details';
    const CLOSE_DELAY = 180; // ms of grace so the mouse can cross the gap into the dropdown
    const timers = new WeakMap();

    const setExpanded = (details, state) => {
      const summary = details.querySelector(':scope > summary');
      if (summary) summary.setAttribute('aria-expanded', state);
    };

    const closeNow = (details) => {
      clearTimeout(timers.get(details));
      details.removeAttribute('open');
      setExpanded(details, 'false');
      details.querySelectorAll('details[open]').forEach((d) => {
        d.removeAttribute('open');
        setExpanded(d, 'false');
      });
    };

    const closeLater = (details) => {
      clearTimeout(timers.get(details));
      timers.set(details, setTimeout(() => closeNow(details), CLOSE_DELAY));
    };

    const open = (details) => {
      clearTimeout(timers.get(details));
      const nav = details.closest('.custom-header__nav-wrapper');
      if (nav) {
        nav.querySelectorAll('details[open]').forEach((d) => {
          if (d !== details && !d.contains(details) && !details.contains(d)) closeNow(d);
        });
      }
      if (!details.hasAttribute('open')) {
        details.setAttribute('open', '');
        setExpanded(details, 'true');
      }
    };

    // Delegated listeners (capture phase) so they keep working after theme-editor re-renders
    document.addEventListener(
      'mouseenter',
      (e) => {
        if (!canHover.matches) return;
        const el = e.target;
        if (el instanceof Element && el.matches(SELECTOR)) open(el);
      },
      true
    );

    document.addEventListener(
      'mouseleave',
      (e) => {
        if (!canHover.matches) return;
        const el = e.target;
        if (el instanceof Element && el.matches(SELECTOR)) closeLater(el);
      },
      true
    );

    // While hovering, clicking the parent label must not toggle the dropdown shut
    document.addEventListener(
      'click',
      (e) => {
        if (!canHover.matches) return;
        const summary = e.target instanceof Element && e.target.closest('summary');
        if (!summary) return;
        const details = summary.parentElement;
        if (details && details.matches(SELECTOR) && details.hasAttribute('open') && details.matches(':hover')) {
          e.preventDefault();
        }
      },
      true
    );

    // Switching out of desktop/mouse mode closes anything hover opened
    canHover.addEventListener('change', () => {
      document.querySelectorAll(SELECTOR + '[open]').forEach(closeNow);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
